import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=76df12f2&scoped=true&"
import script from "./Language.vue?vue&type=script&lang=js&"
export * from "./Language.vue?vue&type=script&lang=js&"
import style0 from "./Language.vue?vue&type=style&index=0&id=76df12f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76df12f2",
  null
  
)

export default component.exports